import { createContext } from "react";
import type { CashFlowAmountCell, CashFlowMatrixRow } from "./cashFlowMatrix.ts";

export interface CashFlowScheduleState {
  canDrillDown: boolean;
  onAmountClick: (row: CashFlowMatrixRow, cell: CashFlowAmountCell) => void;
  hasExpandableRows: boolean;
  hasExpandedRows: boolean;
  onToggleAllRows: () => void;
}

const CashFlowScheduleContext = createContext<CashFlowScheduleState | undefined>(undefined);

export default CashFlowScheduleContext;
